import {Component} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {CommonModule} from "@angular/common";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {AuthenticationService} from "../../../../domain/services/auth/authentication.service";
import {Router, RouterLink} from "@angular/router";
import {ToasterService} from "../../../../common/toaster/toaster.service";
import {finalize} from "rxjs";

@Component({
  selector: 'app-request-password-change',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    RouterLink,
  ],
  templateUrl: './request-password-change.component.html',
  styleUrl: './request-password-change.component.css'
})
export class RequestPasswordChangeComponent {

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  form: FormGroup = new FormGroup({
    email: this.emailFormControl,
  });

  constructor(private readonly authService: AuthenticationService,
              private readonly router: Router,
              private readonly toasterService: ToasterService,) {
  }

  isFormValid() {
    return this.form.valid;
  }

  sendEmail() {
    this.authService.logout();
    const email = this.emailFormControl.value;
    if (email && email.length > 0) {
      this.authService.requestPasswordReset(email).pipe(finalize(() => {
        this.toasterService.show('success', 'Code sent successfully', `Verification code sent to ${email}`);
        this.router.navigate(['auth/email-confirmation']);
      })).subscribe();
    }
  }
}
